import { render, staticRenderFns } from "./myPlaceOrders.vue?vue&type=template&id=6e7db373&scoped=true&"
import script from "./myPlaceOrders.vue?vue&type=script&lang=js&"
export * from "./myPlaceOrders.vue?vue&type=script&lang=js&"
import style0 from "./myPlaceOrders.vue?vue&type=style&index=0&id=6e7db373&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7db373",
  null
  
)

export default component.exports